module.exports = __webpack_public_path__ + "img/layout5.3c4659a3.png";